module.exports = __webpack_public_path__ + "static/media/ico-interesting-no.2a2e8480.svg";